import { LeagueTableProps } from './contracts';
import LeagueTableUI from './LeagueTableUI';
import { useLeagueTableQuery } from '@data/leagueTables/useLeagueTableQuery';
import { SkeletonLoader } from '@ui/common/components/SkeletonLoader';

export default function LeagueTable({
  dataConfig: { selectedLeagueTableId = '11', selectedClubId },
  ...props
}: LeagueTableProps) {
  const params = new URLSearchParams();
  params.set('leagueId', selectedLeagueTableId && selectedLeagueTableId.length > 0 ? selectedLeagueTableId : '11');

  const { data: leagueTable, isLoading: isLoading } = useLeagueTableQuery(
    {
      competitionId: selectedLeagueTableId && selectedLeagueTableId.length > 0 ? selectedLeagueTableId : '11',
    },
    {
      enabled: !!selectedLeagueTableId && selectedLeagueTableId.length > 0,
    }
  );

  if (isLoading) {
    return (
      <div style={{ display: 'block', width: '100%', height: '100%' }}>
        <SkeletonLoader count={21} />
      </div>
    );
  }

  if (!leagueTable) {
    return null;
  }

  return <LeagueTableUI {...props} highlightedClubId={selectedClubId} leagueTable={leagueTable} />;
}
